module.exports = __webpack_public_path__ + "452d4e21eac136f4ec7f4db79e253a19.svg";